// "v1.2 (build 12)" for manifest versions; fallback labels "build-AAAAMMJJ-HHMM" stay as-is.
export const vLabel = (v) => { const l = v.label || v.version; return l.startsWith("build-") ? l : `v${l}`; };
